import autobind from "autobind-decorator";

/**
 * 自动绑定this指针
 */
const AutoBind = autobind;

export default AutoBind;
